module.exports = __webpack_public_path__ + "img/epec.341c9d20.png";